import i18n from '@/helper/i18n';

export default function formatPeriod(value) {
  return i18n.te(`permanentDebts.periodOptions.${value}`)
    ? i18n.t(`permanentDebts.periodOptions.${value}`)
    : value;
}
